import React from "react";
import Constants from "../constants/Constants";
import { navigate } from "@reach/router";

const AllConversations = ({ messages }) => {
  return (
    <>
      {messages.map((msg) => {
        return (
          <div
            className={
              msg.unread === "y" && msg.direction === "to"
                ? "aDM unreadDM"
                : "aDM"
            }
            key={`convomsg${msg.id}`}
            onClick={() => {
              navigate(`${Constants.MA}messages/${msg.site_id}`);
            }}
          >
            <div className="dmAvatar">
              <img
                src={`${Constants.CDN}images/sites/${msg.site_url}.jpg`}
                alt={msg.site_name}
              />
            </div>
            <div className="dmInfo">
              <div className="dmTop">
                <div className="dmModelName">{msg.site_name}</div>
                <div className="dmDate">{msg.readable}</div>
              </div>
              <div className="dmBot">
                {msg.msg === "##audio" ? (
                  <span>audio message attached.</span>
                ) : (
                  msg.msg
                )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default AllConversations;
